import { useState, useEffect } from "react";
import { DESKTOP_BREAKPOINT, isDesktopWidth } from "@/constants/breakpoint";

/**
 * 客户端视口是否为 PC 宽度（> 768px）。
 * 首屏 width 为 null，避免 SSR/CSR 不一致时可配合 CSS 隐藏。
 */
export default function useIsDesktop() {
  const [width, setWidth] = useState(null);

  useEffect(() => {
    const update = () => setWidth(window.innerWidth);
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  return {
    width,
    isDesktop: isDesktopWidth(width),
    /** 尚未拿到视口宽度 */
    isReady: width != null,
  };
}

export { DESKTOP_BREAKPOINT };
